package gr.tech.pdfgenerator.infrastructure.session

import androidx.compose.runtime.mutableStateOf
import gr.tech.pdfgenerator.infrastructure.api.checkUserJWT
import gr.tech.pdfgenerator.models.user.UserPreview

object UserSession {
    var info = mutableStateOf<UserPreview?>(null)
    val checked = mutableStateOf(false)

    fun isLoggedIn(): Boolean {
        return checked.value && info.value != null
    }

    suspend fun setLoggedIn(): Boolean {
        val result = checkUserJWT()
        info.value = result.data
        checked.value = true
        return result.success
    }

    fun setLoggedOut() {
        info.value = null
        checked.value = false
    }
}